module.exports = __webpack_public_path__ + "img/chanpin.0aaeecb8.webp";